import { setupClients } from '@internetworkexpert/js-common'

const env = process.env.VUE_APP_ENVIRONMENT
const { SUBSCRIPTIONS, UAA, MIXPANEL, UAA_ANONYMOUS, BUSINESS_PYTHON } =
  env !== undefined
    ? setupClients(env)
    : { SUBSCRIPTIONS: {}, UAA: {}, MIXPANEL: {}, UAA_ANONYMOUS: {}, BUSINESS_PYTHON: {} }

export { UAA, SUBSCRIPTIONS, MIXPANEL, UAA_ANONYMOUS, BUSINESS_PYTHON }
